import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle } from '../components/ui/card';
import { Heart, Activity, Shield } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { insuranceProducts } from '../mock';

const Insurance = () => {
  const iconMap = {
    "Life Insurance": Heart,
    "Health Insurance": Activity,
    "General Insurance": Shield
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Page Header */}
      <section className="pt-24 pb-8 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 via-white to-green-50/30">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 text-center">
            <h1 className="text-3xl sm:text-4xl font-bold text-[#DC143C] mb-4">
              Insurance Solutions
            </h1>
            <p className="text-base text-gray-600">
              Protect what matters most with our comprehensive insurance coverage
            </p>
          </div>
        </div>
      </section>

      {/* Insurance Cards */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {insuranceProducts.map((product) => {
              const IconComponent = iconMap[product.name] || Shield;
              return (
                <Link key={product.id} to={product.path}>
                  <Card className="group hover:shadow-xl transition-all duration-300 border-2 border-gray-200 hover:border-green-600 cursor-pointer h-full">
                    <CardHeader className="text-center py-12">
                      <div className="w-20 h-20 bg-green-50 rounded-xl flex items-center justify-center mb-6 mx-auto group-hover:bg-green-600 transition-colors duration-300">
                        <IconComponent className="w-10 h-10 text-green-600 group-hover:text-white transition-colors duration-300" />
                      </div>
                      <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-green-600 transition-colors">
                        {product.name}
                      </CardTitle>
                    </CardHeader>
                  </Card>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Insurance;